module.exports = __webpack_public_path__ + "media/native-apps/jamtland-25b0bfbb.webp";